<div *ngIf="isOpen" class="flex absolute top-0 left-0 h-screen w-screen bg-black/50">
  <div class="flex flex-col gap-3 w-screen h-screen pb-3 lg:w-1/3 lg:max-w-96 foreground">
    <header class="flex items-center justify-between h-16 gap-3 px-3">
      <h2 class="text-xl font-bold text-color">Filtros</h2>

      <button
        lButton
        class="!rounded-full !w-8 !h-8"
        (click)="close()"
      >
        <l-icon class="text-xl">
          close
        </l-icon>
      </button>
    </header>

    <div class="px-3 overflow-y-auto">
      <ng-content />
    </div>

    <div class="flex flex-col lg:flex-row gap-2 mt-auto pt-3 px-3">
      <button (click)="clear()" lButton>
        <l-icon class="text-2xl">filter_list_off</l-icon>
          <span class="ml-2">Limpar</span>
      </button>

      <button (click)="confirm()" lButton bType="primary">
          <span>Confirmar</span>
      </button>
    </div>
  </div>

  <div class="flex-1" (click)="close()"></div>
</div>
